import OwnerReview from './OwnerReview';
import { OwnerReviewQuery } from './OwnerReviewQuery.graphql';

OwnerReview.query = OwnerReviewQuery;

export default OwnerReview;
